module.exports = __webpack_public_path__ + "static/media/auth-img2.a5cb0f0f.jpg";